<template>

  <section class="application-create__form">
    <div class="container-xxxl">
      <div class="row">
        <div class="col-xxl-6 offset-xxl-3">
          <h3 class="application__form__title">{{ $lang.app.APPLICANT_INFORMATION }}</h3>
          <div class="application__form__block">
            <div v-for="(applicant, index) in applicants" :key="index">
              <div v-if="reassignable" class="flex justify-end items-center mb-4">
                <button type="button" @click="$emitter.emit('open-applicant-application-applicant-reassign-modal', applicant)"
                             class="button button__icon--left button--default button--bordered">
                  {{ $lang.app.REASSIGN }}
                </button>
              </div>
              <div class="add__field__item">
                <div v-if="applicant.user.userInfo?.type === userTypesGetValueByKey('INDIVIDUAL_ENTITY')"
                     class="stack__list">
                  <div class="stack__label">{{ $lang.app.FULL_NAME }}</div>
                  <div class="stack__value">
                    {{ applicant.user.userInfo?.person?.surname }} {{ applicant.user.userInfo?.person?.name }} {{ applicant.user.userInfo?.person?.patronymic }}</div>
                </div>
                <div v-if="applicant.user.userInfo?.type === userTypesGetValueByKey('LEGAL_ENTITY')"
                     class="stack__list">
                  <div class="stack__label">{{ $lang.app.FULL_NAME }}</div>
                  <div class="stack__value">
                    {{ applicant.user.userInfo?.organization?.surname }} {{ applicant.user.userInfo?.organization?.name }} {{ applicant.user.userInfo?.organization?.patronymic }}</div>
                </div>
                <div v-if="applicant.userInfo?.type === userTypesGetValueByKey('INDIVIDUAL_ENTREPRENEUR')"
                     class="stack__list">
                  <div class="stack__label">{{ $lang.app.FULL_NAME }}</div>
                  <div class="stack__value">
                    {{ applicant.user.userInfo?.individualEnterprise?.surname }} {{ applicant.user.userInfo?.individualEnterprise?.name }} {{ applicant.user.userInfo?.individualEnterprise?.patronymic }}</div>
                </div>
                <div class="stack__list">
                  <div class="stack__label">{{ $lang.app.PHONE }}</div>
                  <div class="stack__value">{{ applicant.user.userInfo?.contactDetail?.phone }}</div>
                </div>
                <div class="stack__list">
                  <div class="stack__label">{{ $lang.app.EMAIL }}</div>
                  <div class="stack__value">{{ applicant.user.login }}</div>
                </div>
              </div>
              <div v-for="(certifyingDocument, index) in applicant.certifyingDocuments" :key="index"
                   class="add__field__item">
                <div class="add__field__header">
                  {{ certifyingDocument.name }}
                  <button v-if="editable" type="button" @click="removeDoc(applicant, certifyingDocument)">
                    <svg viewBox="0 0 24 24" width="24" height="24">
                      <use xlink:href="@/assets/v2/img/sprite.svg#icon__remove"></use>
                    </svg>
                  </button>
                </div>
                <div class="stack__list">
                  <div class="stack__label">{{ $lang.app.TYPE }}</div>
                  <div class="stack__value">{{ $lang.app[certifyingDocumentTypesGetLabelRefByValue(certifyingDocument.type)] }}</div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    <div class="stack__list">
                      <div class="stack__label">{{ $lang.app.NUMBER }}</div>
                      <div class="stack__value">{{ certifyingDocument.number }}</div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="stack__list">
                      <div class="stack__label">{{ $lang.app.DATE }}</div>
                      <div class="stack__value">{{ $moment(certifyingDocument.docDate).format("DD.MM.YYYY") }}</div>
                    </div>
                  </div>
                </div>
                <div class="stack__list">
                  <div class="stack__label">{{ $lang.app.FILE }}</div>
                  <button v-if="certifyingDocument.file" type="button" class="file__item"
                          @click="$emitter.emit('open-applicant-application-pdf-file', certifyingDocument.file)">
                    <svg viewBox="0 0 24 24" width="24" height="24">
                      <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                    </svg>
                    <span class="file__item__name">
                        {{ certifyingDocument.file.filename }}
                    </span>
                  </button>
                </div>
                <button v-if="editable" type="button" class="add__field__edit"
                        @click="$emitter.emit('open-applicant-application-applicant-cert-doc-edit-modal', {applicant, doc: certifyingDocument})">
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <use xlink:href="@/assets/v2/img/sprite.svg#icon__edit"></use>
                  </svg>
                  {{ $lang.app.EDIT }}
                </button>
              </div>
              <div v-if="editable" class="input__group">
                <button type="button" class="button button--full button__icon--left button--default button--bordered button__add__customers__docs"
                        @click="$emitter.emit('open-applicant-application-applicant-cert-doc-create-modal', applicant)">
                  <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
                    <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
                  </svg>
                  <span class="button__text">{{ $lang.app.CERTIFYING_DOCUMENTS }}</span>
                </button>
              </div>
            </div>
            <ApplicantReassignModal/>
            <CertDocCreateModal/>
            <CertDocEditModal/>

            <div v-for="(confidant, index) in confidants" :key="index"
                 class="add__field__item">
              <div class="add__field__header">
                {{ confidant.name }}
                <button v-if="confidantEditable" type="button" @click="removeConfidant(confidant)">
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <use xlink:href="@/assets/v2/img/sprite.svg#icon__remove"></use>
                  </svg>
                </button>
              </div>
              <div class="stack__list">
                <div class="stack__label">{{ $lang.app.PIN }}</div>
                <div class="stack__value">{{ confidant.pin }}</div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="stack__list">
                    <div class="stack__label">{{ $lang.app.FULL_NAME }}</div>
                    <div class="stack__value">{{ confidant.surname }} {{ confidant.name }} {{ confidant.patronymic }}</div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="stack__list">
                    <div class="stack__label">{{ $lang.app.PHONE }}</div>
                    <div class="stack__value">{{ confidant.phone }}</div>
                  </div>
                </div>
              </div>
              <div class="stack__list">
                <div class="stack__label">{{ $lang.app.FILE }}</div>
                <button v-if="confidant.files" type="button" class="file__item"
                        @click="loadFile(confidant)">
                  <svg viewBox="0 0 24 24" width="24" height="24">
                    <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                  </svg>
                  <span class="file__item__name">
                        {{ confidant.files.filename }}
                    </span>
                </button>
              </div>
              <button v-if="confidantEditable" type="button" class="add__field__edit"
                      @click="$emitter.emit('open-applicant-application-confidant-edit-modal', confidant)">
                <svg viewBox="0 0 24 24" width="24" height="24">
                  <use xlink:href="@/assets/v2/img/sprite.svg#icon__edit"></use>
                </svg>
                {{ $lang.app.EDIT }}
              </button>
            </div>
            <div v-if="confidantEditable" class="input__group">
              <button type="button" class="button button--full button__icon--left button--default button--bordered button__add__customers__docs"
                      @click="$emitter.emit('open-applicant-application-confidant-create-modal')">
                <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
                  <use xlink:href="@/assets/v2/img/sprite.svg#icon__plus"></use>
                </svg>
                <span class="button__text">{{ $lang.app.CONFIDANT }}</span>
              </button>
            </div>
            <ConfidantCreateModal/>
            <ConfidantEditModal/>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="application-create__controls">
    <div class="container-fluid">
      <div class="application-create__controls__wrapper">
        <button type="button" @click="$router.go(-1)" class="button button--cancel">{{ $lang.app.CANCEL }}</button>
        <router-link :to="{
          name: 'ApplicantApplicationCustomerDetail',
          params: {applicationId: application.id}
        }" class="button button__icon--right">{{ $lang.app.NEXT }}
          <svg class="icon" viewBox="0 0 24 24" width="24" height="24">
            <use xlink:href="@/assets/v2/img/sprite.svg#arrow__right"></use>
          </svg>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getValueByKey as userTypesGetValueByKey,
  getLabelRefByValue as userTypesGetLabelRefByValue,
} from "../../../../helpers/constants/userTypes";
import applicationApi from "../../../../api/applicant/application";
import {
  getLabelRefByValue as certifyingDocumentTypesGetLabelRefByValue,
} from "../../../../helpers/constants/certifyingDocumentTypes";
import CertDocCreateModal from "../../../../components/applicant/application/modals/ApplicantCertDocCreateModal.vue";
import ConfidantCreateModal from "../../../../components/applicant/application/modals/ConfidantCreateModal.vue";
import ConfidantEditModal from "../../../../components/applicant/application/modals/ConfidantEditModal.vue";
import CertDocEditModal from "../../../../components/applicant/application/modals/ApplicantCertDocEditModal.vue";
import ApplicantReassignModal from "../../../../components/applicant/application/modals/ApplicantReassignModal.vue";

export default {
  name: "ApplicantApplicationApplicantDetail",
  props: {
    application: Object
  },
  components: {
    CertDocCreateModal,
    ConfidantCreateModal,
    ConfidantEditModal,
    CertDocEditModal,
    ApplicantReassignModal,
  },
  computed: {
    editable() {
      return this.application.actions.some(action => action.constName === 'APPLICANT_EDIT_ACTION')
    },
    reassignable() {
      return this.application.actions.some(action => action.constName === 'RE_ASSIGN_EXECUTOR')
    },
    confidantEditable() {
      return this.application.actions.some(action => action.constName === 'APPLICANT_EDIT_ACTION')
          && (this.userTypesGetValueByKey('LEGAL_ENTITY') === this.$store.getters.getCurrentUser.userInfo.type)
    },
    applicants() {
      return this.application.applicants
    },
    confidants() {
      return this.application.applicationConfidants
    },
  },
  methods: {
    userTypesGetValueByKey,
    userTypesGetLabelRefByValue,
    certifyingDocumentTypesGetLabelRefByValue,
    loadFile(confidant) {
      this.$emitter.emit('open-loader-modal')
      applicationApi.loadConfidantFile(this.application.id, confidant.id).then(res => {
        this.$emitter.emit('open-file-modal', res.data)
      }).finally(() => {
        this.$emitter.emit('close-loader-modal')
      })
    },
    removeConfidant(confidant) {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_DELETE,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          applicationApi.deleteConfidant(this.application.id, confidant.id)
              .then(() => {
                this.$emitter.emit('refresh-application', {reload: false})
                this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
              })
              .catch(error => {
                this.$snotify.error(error)
              })
        }
      })
    },
    removeDoc(applicant, doc) {
      this.$swal.fire({
        icon: 'warning',
        text: this.$lang.app.ARE_YOU_SURE_TO_DELETE,
        showDenyButton: true,
        confirmButtonColor: '#4c9ac7',
        denyButtonColor: '#6e7881',
        confirmButtonText: this.$lang.app.YES,
        denyButtonText: this.$lang.app.NO,
      }).then((result) => {
        if (result.isConfirmed) {
          applicationApi.deleteApplicantCertifyingDocument(applicant.id, doc.id)
              .then(() => {
                this.$emitter.emit('refresh-application', {reload: false})
                this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
              })
              .catch(error => {
                this.$snotify.error(error)
              })
        }
      })
    }
  }
};
</script>
